import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IWorkflowFormTemplateState } from './workflow-form-template.types';
import {
  IWorkflowFormFieldData,
  IWorkflowFormFieldOptionTodoData,
  IWorkflowFormFieldOptionTodoTemplateData,
  IWorkflowFormTemplateData,
  IWorkflowFormTemplateRevisionData,
  WorkflowFormTemplatePrefixTypeEnum,
  IWorkflowStateData,
  IUserData
} from '@/models';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: IWorkflowFormTemplateState = {
  version: 1,
  workflowFormTemplatesWithPublishedRevisions: [] as IWorkflowFormTemplateData[],
  workflowFormTemplates: [] as IWorkflowFormTemplateData[],
  lastCreatedWorkflowFormTemplateId: null as null | number,
  lastCreatedWorkflowFormTemplateRevisionId: null as null | number,
  workflowFormTemplateRevisions: [] as IWorkflowFormTemplateRevisionData[],
  formFields: [] as IWorkflowFormFieldData[],
  formFieldOptionTodos: [] as IWorkflowFormFieldOptionTodoData[],
  formTodoTempates: [] as IWorkflowFormFieldOptionTodoTemplateData[],
  templateWorkflowStates: [] as IWorkflowStateData[],
  workflowTemplateUsers: [] as IUserData[],

  formTemplatePrefixTypes: [
    {
      display_name: 'Text',
      value: WorkflowFormTemplatePrefixTypeEnum.Text
    },
    {
      display_name: 'Date',
      value: WorkflowFormTemplatePrefixTypeEnum.Date
    },
    {
      display_name: 'Fiscal Date',
      value: WorkflowFormTemplatePrefixTypeEnum.Fiscal
    },
    {
      display_name: 'None',
      value: WorkflowFormTemplatePrefixTypeEnum.None
    }
  ]
};

const namespaced = true;

export const workflowFormTemplate: Module<
  IWorkflowFormTemplateState,
  IRootState
> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
